module.exports = __webpack_public_path__ + "static/img_4421-53f6051c6276b0a3bdc45fd598923179.webp";